export default __webpack_public_path__ + "static/media/liposuction.c335b5d2.svg";